/**
 * @fileoverview POST handler for the "/apps/:app_group_id/products_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdProductsSettingsCacheKeys } from "./constants";
import type { PostAppsAppGroupIdProductsSettingsProps, PostAppsAppGroupIdProductsSettingsResult } from "./types";

export const postAppsAppGroupIdProductsSettings = reactQueryMutationAdapter(
  appsAppGroupIdProductsSettingsCacheKeys,
  (props: PostAppsAppGroupIdProductsSettingsProps): Promise<PostAppsAppGroupIdProductsSettingsResult> => {
    return fetch(`/apps/${props.appGroupId}/products_settings`, "POST", props);
  }
);
